import axios from 'axios';

export default {
    async fetchTeams() {
        return axios.get('/teams');
    },

    async fetchTeamById(id) {
        return axios.get(`/teams/${id}`);
    },

    async addTeam(team) {
        return axios.post('/teams',
            team,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async updateOverview(teamInfo) {
        return axios.put('/teams/update-team-overview',
            teamInfo,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async updateProfessions(teamId, professions) {
        return axios.put('/teams/update-team-professions',
            {id: teamId, professions},
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async updateMembers(teamId, members) {
        return axios.put('/teams/update-team-memberships',
            {id: teamId, teamMemberships: members},
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }
}
